import { createApp } from 'vue';
import FavoriteButton from '@components/FavoriteButton.vue';

export const initFavoriteButtonLoader = (): void => {
  document.querySelectorAll('.favorite-button-app')
    .forEach((vueFavoriteElement: Element) => {
      const offerHashId = vueFavoriteElement.getAttribute('data-offer-hash-id') as string;

      createApp(
        FavoriteButton,
        {
          offerHashId,
          isActive: window.homepageInitialAppState.favoriteHashIds.includes(offerHashId),
        },
      ).mount(vueFavoriteElement);
    });
};
